<ng-container *ngIf="shouldShowHistorySection">
	<div class="card card-plain" *ngIf="wrapInCard">
		<div class="card-body">
			<ng-container *ngTemplateOutlet="historyBody"></ng-container>
		</div>
	</div>
	<ng-container *ngIf="!wrapInCard">
		<ng-container *ngTemplateOutlet="historyBody"></ng-container>
	</ng-container>
</ng-container>

<ng-template #historyBody>
	<div class="row justify-content-center">
		<div class="col-12">
			<div class="review-approval-history">
				<h3 *ngIf="showHeading">Review Comments &amp; Approval History</h3>
				<div class="review-history-list">
					<article class="review-history-entry" *ngFor="let history of reviewHistoryEntries">
						<header class="review-history-entry__header">
							<span class="review-history-entry__author">{{ history.createdBy }}</span>
							<time class="review-history-entry__time" [attr.datetime]="history.createdDate">{{
								history.createdDate | date : 'medium'
							}}</time>
						</header>
						<div class="review-history-entry__body">
							<div class="review-history-field">
								<span class="review-history-field__label">Action</span>
								<span class="review-history-field__value">{{ formatAction(history.action) }}</span>
							</div>
							<div class="review-history-field" *ngIf="history.comment && history.comment.trim().length > 0">
								<span class="review-history-field__label">Reviewer comment</span>
								<span class="review-history-field__value review-history-field__value--multiline">{{
									history.comment
								}}</span>
							</div>
							<div class="review-history-field" *ngIf="history.approvers?.length > 0">
								<span class="review-history-field__label">Approval Snapshot at Time of Action</span>
								<ul class="review-history-snapshot">
									<li *ngFor="let item of history.approvers" class="review-history-snapshot__item">
										<span class="review-history-snapshot__name">{{ item.name }}</span>
										<span
											*ngIf="item.hasApproved"
											class="review-history-snapshot__status review-history-snapshot__status--approved"
										>
											Approved
											<ng-container *ngIf="item.isAdminOverride && item.approvedBy">
												by {{ item.approvedBy }}
											</ng-container>
											<ng-container *ngIf="item.approvedDate">
												on {{ item.approvedDate | date : 'medium' }}
											</ng-container>
										</span>
										<span *ngIf="item.hasApproved && item.isAdminOverride" class="review-history-snapshot__badge"
											>Admin Override</span
										>
										<span
											*ngIf="!item.hasApproved"
											class="review-history-snapshot__status review-history-snapshot__status--pending"
											>Not yet approved</span
										>
									</li>
								</ul>
							</div>
							<div class="review-history-field" *ngIf="history.attachments?.length > 0">
								<span class="review-history-field__label">Attachments</span>
								<ul class="review-history-attachments">
									<li *ngFor="let attachment of history.attachments">
										<a
											*ngIf="attachment.linkUrl"
											class="review-history-attachment-link"
											[href]="attachment.linkUrl"
											target="_blank"
											rel="noopener noreferrer"
											[attr.download]="attachment.documentName || null"
										>
											<i class="fas fa-download" aria-hidden="true"></i>
											<span>{{ attachment.documentName }}</span>
										</a>
										<span
											*ngIf="!attachment.linkUrl"
											class="review-history-attachment-fallback"
											[title]="attachment.documentName"
										>
											<i class="fas fa-file" aria-hidden="true"></i>
											{{ attachment.documentName }}
											<small class="text-muted">(download not available)</small>
										</span>
									</li>
								</ul>
							</div>
						</div>
					</article>
				</div>
			</div>
		</div>
	</div>
</ng-template>
